<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('tipo-recomendacao') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('cadastros') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({ name: 'agro-tiporecomendacao-list' })
                                        "
                                        >{{ $t('tipo-recomendacao') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id && tipoRecomendacao.descricao
                                            ? $route.params.id + ' - ' + tipoRecomendacao.descricao
                                            : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-tiporecomendacao' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!usuarioIntegracao && !isUpdate && permissao.create) ||
                                (!usuarioIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(3)"
                                ref="idagrotiporecomendacaoerpInput"
                                v-model="tipoRecomendacao.idagrotiporecomendacaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-7">
                            <v-input
                                :id="generateId(10)"
                                ref="nomeInput"
                                v-model="tipoRecomendacao.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                msg="msg-campo-obrigatorio"
                                :invalid="!tipoRecomendacao.descricao"
                                uppercase
                                tooltipLabel="tipo-recomendacao-tooltip-descricao"
                                tooltipSize="is-small"
                                title="descricao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                :required="true"
                            />
                        </div>

                        <div class="column is-3">
                            <vss-select
                                :id="generateId(20)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="tipoRecomendacao.id == null"
                                title="situacao"
                            />
                        </div>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <label>
                                {{ $t('produto') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n: $t('produto') }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(30)"
                                    :type="checks.produto.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.produto.habilita"
                                    @click="changeCheckHabilita('produto')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(40)"
                                    :type="checks.produto.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.produto.obriga"
                                    @click="changeCheckObriga('produto')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                        <div class="column is-4">
                            <label>
                                {{ $t('quantidade') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n: $t('quantidade') }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(50)"
                                    :type="checks.quantidade.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.quantidade.habilita"
                                    @click="changeCheckHabilita('quantidade')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(60)"
                                    :type="checks.quantidade.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.quantidade.obriga"
                                    @click="changeCheckObriga('quantidade')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                        <div class="column is-4">
                            <label>
                                {{ $t('dosagem') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n: $t('dosagem') }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(70)"
                                    :type="checks.dosagem.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.dosagem.habilita"
                                    @click="changeCheckHabilita('dosagem')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(80)"
                                    :type="checks.dosagem.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.dosagem.obriga"
                                    @click="changeCheckObriga('dosagem')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <label>
                                {{ $t('pressao-bico') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n: $t('pressao-bico') }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(90)"
                                    :type="checks.pressaoBico.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.pressaoBico.habilita"
                                    @click="changeCheckHabilita('pressaoBico')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(100)"
                                    :type="checks.pressaoBico.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.pressaoBico.obriga"
                                    @click="changeCheckObriga('pressaoBico')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                        <div class="column is-4">
                            <label>
                                {{ $t('forma-aplicacao') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n:$t('forma-aplicacao')  }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(110)"
                                    :type="checks.formaAplicacao.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.formaAplicacao.habilita"
                                    @click="changeCheckHabilita('formaAplicacao')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(120)"
                                    :type="checks.formaAplicacao.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.formaAplicacao.obriga"
                                    @click="changeCheckObriga('formaAplicacao')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                        <div class="column is-4">
                            <label>
                                {{ $t('descricao') }}
                                <b-icon
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="
                                        $t('tipo-recomendacao-tooltip-geral', 
                                            { n: $t('descricao') }
                                        )
                                    "
                                />
                            </label>
                            <div class="group-buttons">
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(130)"
                                    :type="checks.descricaoGeral.habilita ? 'is-primary' : ''"
                                    :outlined="!checks.descricaoGeral.habilita"
                                    @click="changeCheckHabilita('descricaoGeral')"
                                >
                                    <span>{{ $t('habilita') }}</span>
                                </b-button>
                                <b-button
                                    class="expanded-buttons"
                                    :id="generateId(140)"
                                    :type="checks.descricaoGeral.obriga ? 'is-primary' : ''"
                                    :outlined="!checks.descricaoGeral.obriga"
                                    @click="changeCheckObriga('descricaoGeral')"
                                >
                                    <span>{{ $t('obriga') }}</span>
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoRecomendacaoService from '@/services/agro/TipoRecomendacaoService';
import TipoRecomendacaoValidation from '@/services/validations/agro/TipoRecomendacaoValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_TIPORECOMENDACAO'
            ),
            service: new TipoRecomendacaoService(this.$http, this.$router),
            validations: new TipoRecomendacaoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            tipoRecomendacao: {
                idagrotiporecomendacao: null,
                idagrotiporecomendacaoerp: null,
                descricao: '',
                situacao: null,
                ativaproduto: 0,
                ativadosagem: 0,
                ativapressaobico: 0,
                ativaformaaplicacao: 0,
                ativadescricaogeral: 0,
                ativaqtde: 0,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },

            checks: {
                produto: { habilita: false, obriga: false },
                quantidade: { habilita: false, obriga: false },
                dosagem: { habilita: false, obriga: false },
                pressaoBico: { habilita: false, obriga: false },
                formaAplicacao: { habilita: false, obriga: false },
                descricaoGeral: { habilita: false, obriga: false },
            },
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;
        this.permissao = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-tiporecomendacao'
        );
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'tipo-recomendacao' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
                this.isUpdate = true;
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.tipoRecomendacao = value.content;
                    this.situacao = this.situacoes[this.tipoRecomendacao.situacao];

                    this.checks.produto.habilita =
                        this.tipoRecomendacao.ativaproduto == 0 ? false : true;
                    this.checks.produto.obriga =
                        this.tipoRecomendacao.ativaproduto == 2 ? true : false;
                    this.checks.quantidade.habilita =
                        this.tipoRecomendacao.ativaqtde == 0 ? false : true;
                    this.checks.quantidade.obriga =
                        this.tipoRecomendacao.ativaqtde == 2 ? true : false;
                    this.checks.dosagem.habilita =
                        this.tipoRecomendacao.ativadosagem == 0 ? false : true;
                    this.checks.dosagem.obriga =
                        this.tipoRecomendacao.ativadosagem == 2 ? true : false;
                    this.checks.pressaoBico.habilita =
                        this.tipoRecomendacao.ativapressaobico == 0 ? false : true;
                    this.checks.pressaoBico.obriga =
                        this.tipoRecomendacao.ativapressaobico == 2 ? true : false;
                    this.checks.formaAplicacao.habilita =
                        this.tipoRecomendacao.ativaformaaplicacao == 0 ? false : true;
                    this.checks.formaAplicacao.obriga =
                        this.tipoRecomendacao.ativaformaaplicacao == 2 ? true : false;
                    this.checks.descricaoGeral.habilita =
                        this.tipoRecomendacao.ativadescricaogeral == 0 ? false : true;
                    this.checks.descricaoGeral.obriga =
                        this.tipoRecomendacao.ativadescricaogeral == 2 ? true : false;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        changeCheckHabilita(v) {
            this.checks[v].habilita = !this.checks[v].habilita;
            if (!this.checks[v].habilita) this.checks[v].obriga = false;
        },
        changeCheckObriga(v) {
            this.checks[v].obriga = !this.checks[v].obriga;
            if (this.checks[v].obriga) this.checks[v].habilita = true;
        },
        mapChecksToSave(v) {
            if (!this.checks[v].habilita) {
                return 0;
            } else if (this.checks[v].habilita && !this.checks[v].obriga) {
                return 1;
            } else if (this.checks[v].obriga) {
                return 2;
            } else {
                console.log('Valor inválido!');
            }
        },
        save() {
            this.isLoading = true;

            let tipoRecomendacaoTemp = Object.assign({}, this.tipoRecomendacao);
            tipoRecomendacaoTemp = this.mapTosave(tipoRecomendacaoTemp);
            tipoRecomendacaoTemp.situacao = this.situacao.id;

            tipoRecomendacaoTemp.ativaproduto = this.mapChecksToSave('produto');
            tipoRecomendacaoTemp.ativadosagem = this.mapChecksToSave('dosagem');
            tipoRecomendacaoTemp.ativapressaobico = this.mapChecksToSave('pressaoBico');
            tipoRecomendacaoTemp.ativaformaaplicacao = this.mapChecksToSave('formaAplicacao');
            tipoRecomendacaoTemp.ativadescricaogeral = this.mapChecksToSave('descricaoGeral');
            tipoRecomendacaoTemp.ativaqtde = this.mapChecksToSave('quantidade');

            if (this.validations.validate(tipoRecomendacaoTemp, this.$refs)) {
                this.isSaving = true;

                this.service
                    .save(tipoRecomendacaoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-tipo-recomendacao';
                            if (this.tipoRecomendacao.id != null) {
                                msg = 'msg-edit-tipo-recomendacao';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.redirectToList();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        mapOnSave(value) {
            return {
                id: value.id,
                descricao: value.descricao,
            };
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: 'agro-tiporecomendacao-list',
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}

.expanded-buttons {
    width: 50% !important;
}
</style>
